import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthService } from './auth.service';

@NgModule({
  imports: [CommonModule],
  providers: [AuthService, provideHttpClient(withInterceptorsFromDi())]
})
export class AuthModule {}
